import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../../../atoms/Icon'
import { ICON_NAMES } from '../../../../constants'

const CollapsibleColumnHeader = ({
  column,
  isCollapsed,
  onToggle
}) => {
  if (!column.isCollapsible) {
    return column.render('Header')
  }

  const handleClick = (e) => {
    e.stopPropagation() // Prevent sort trigger
    onToggle(column.groupId)
  }

  return (
    <div className='__collapsible-column-header'>
      <span className='__header-text'>
        {column.render('Header')}
      </span>
      <button
        className='__collapse-toggle'
        onClick={handleClick}
        aria-label={isCollapsed ? 'Expand column group' : 'Collapse column group'}
        aria-expanded={!isCollapsed}
        type='button'
      >
        <Icon
          name={isCollapsed ? ICON_NAMES.addCircle : ICON_NAMES.removeCircle}
          className='__collapse-icon'
        />
      </button>
    </div>
  )
}

CollapsibleColumnHeader.propTypes = {
  column: PropTypes.object.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
}

export default CollapsibleColumnHeader
